import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { Notify } from "../../based/Notify";
import ArtistServices from "../../based/services/ArtistServices"
import Logo from "./Image/LogoArtist.svg"
import { CONSTANTS, NOTIFY } from "../../based/Constants";
import Request from "../../based/Request";
import Common from "../../based/Common";
import cookie from 'react-cookies';

function ModalUpdateInfo({setIsModal, user,getPersonalInfo}) {
    const [userModel, setUserModel] = useState({...user})
    const [msgFN, setMsgFN] = useState("")
    const [msgLN, setMsgLN] = useState("")
    const [msgAvt, setMsgAvt] = useState("")
    const [msgPhone, setMsgPhone] = useState("")


    const handleLogout  = ()=>{
        Common.RemoveToken();
        cookie.remove('token');
        window.location.href = '/login';
    }



    function handleChange(e) {
        let reader = new FileReader();
        let file = e.target.files[0];
        if (file) {
            reader.onloadend = () => {
                Request.UploadImage(file)
                    .then((res) => {
                        if (res && res.data) {
                            setUserModel( {
                                ...userModel,
                                avatar: res.data.imageUrl
                            })
                        } else {
                            let errMsg =
                                res.errors && res.errors.length > 0
                                    ? res.errors.reduce((prev, item, idx) => {
                                            return `${prev}${item.value}<br/>`;
                                        }, "")
                                    : "" || CONSTANTS.MSG_ERROR;
                            Notify(NOTIFY.ERROR, NOTIFY.ERROR, errMsg);
                        }


                    })
                    .catch((err) => {


                    });
            };

            reader.readAsDataURL(file);
        }
        
    }
    const isValid = () =>{
        let check = true;
        if(!userModel.avatar){
            check = false;
            setMsgAvt("Chưa chọn avatar")
        }else{
            setMsgAvt("")
        }
        if(!userModel.firstName){
            check = false;
            setMsgFN("Không được để trống")
        }
        else{
            setMsgFN("")
        }
        if(!userModel.lastName){
            check = false;
            setMsgLN("Không được để trống")

        }else{
            setMsgLN("")
        }
        if(!Common.isValidPhone(userModel.phoneNumber)){
            check = false;
            setMsgPhone("Sai định dạng số điện thoại !!!");
        }else{
            setMsgPhone("")
        }



        return check;
    }
    const handleUpdate = async() =>{
        if(isValid()){
            let [err, data] = await ArtistServices.UpdateInfoUserArtist({...userModel});
            if (!err && data == 1) {
                Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Thay đổi thông tin thành công !!!");
                getPersonalInfo()
                setIsModal(false);
            } else {
                if (data == -2) {
                    Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Đã tồn tại");
                } else {
                    Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Thất bại");
                }
            }
        }
        
    }
    return ( 
        <StyleModal onClick={()=>{setIsModal(false)}}>
            <div className="modal-art" onClick={(e)=>{
                e.stopPropagation()
            }}>
                <div className="modal-art-header">
                    <h3>Thông tin tài khoản</h3>
                    <div className="close-art" onClick={()=>{setIsModal(false)}}>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 1L1 14" stroke="white" stroke-width="2" stroke-linecap="round"/>
                            <path d="M14 14L1 0.999999" stroke="white" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </div>
                </div>
                <div className="modal-art-body">
                    <div className="box-avatar-modal">
                        <img src={userModel.avatar ? userModel.avatar : Logo}/>
                        <input type="file" id="avatar-change" hidden onChange={(e)=>{
                            handleChange(e)
                        }}/>
                        {msgAvt && <span className="error-msg avt">{msgAvt}</span>}
                        <label className="label-model-img" hidden for="avatar-change">Chọn ảnh</label>
                    </div>
                    <div className="name-artist">
                        {(userModel.firstName || userModel.lastName) && <p>{userModel.firstName + " " + userModel.lastName}</p>}
                        {userModel.nickName && <p className="nickname">({userModel.nickName})</p>}
                    </div>
                    {/* <div className="box-input">
                        <div className="col-info-50">
                            <input type="text" placeholder="Họ" disabled  value={userModel.firstName}
                                onChange={(e)=>{
                                    setUserModel( {
                                        ...userModel,
                                        firstName: e.target.value
                                    })
                                }}
                            />
                            {msgFN && <span className="error-msg">{msgFN}</span>}
                        </div>

                        <div className="col-info-50">
                            <input type="text" disabled placeholder="Tên" value={userModel.lastName}
                            onChange={(e)=>{
                                setUserModel( {
                                    ...userModel,
                                    lastName: e.target.value
                                })
                            }}/>
                            {msgLN && <span className="error-msg">{msgLN}</span>}
                        </div>

                    </div>
                    <input type="text" disabled placeholder="Nickname" value={userModel.nickName}
                    onChange={(e)=>{
                        setUserModel( {
                            ...userModel,
                            nickName: e.target.value
                        })
                    }}/>

                    <input type="text" disabled placeholder="Số điện thoại" value={userModel.phoneNumber}
                    onChange={(e)=>{
                        setUserModel( {
                            ...userModel,
                            phoneNumber: e.target.value
                        })
                    }}/>
                    {msgPhone && <span className="error-msg">{msgPhone}</span>} */}

                </div>
                <div  className="box-footer">
                    <div className="btn-logout" onClick={handleLogout}>Đăng xuất</div>
                </div>
                {/* <div className="modal-art-footer" >
                    <button className="btn-model" onClick={()=>{
                    handleUpdate()
                    }}>Cập nhật</button>
                </div> */}

            </div>
        </StyleModal>
    );
}

const StyleModal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0,0,0,0.3);
    display: grid;
    place-items: center;


    .modal-art{
        max-width: 95%;
        background-color: #313131;
        border-radius: 10px;
        min-width: 300px;


        .error-msg{
            color: red;
            font-size: 12px;
            display: block;
            text-align: left;
            margin-top: -5px;
            margin-bottom: 10px;

            &.avt{
                text-align: center;
                margin-bottom: 0;
                margin-top: 0;
            }
        }


        .box-avatar-modal{
            margin-bottom: 10px;

            img{
                width: 120px;
                height: 120px;
                object-fit: cover;
                border-radius: 50%;
                margin: 0 auto 10px;
                display: block;
            }
        }
        .modal-art-header{
            padding: 20px 20px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;

            h3{
                font-weight: 600;
                font-size: 16px;
                line-height: 20px;
                letter-spacing: -0.3px;
                color: #FFFFFF;
            }
            .close-art{
                cursor: pointer;
            }
        }


        .modal-art-body{
            padding: 20px;
            text-align: center;

            .label-model-img{
                margin: 10px auto;
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                letter-spacing: -0.3px;
                color: #06F1B9;
                cursor: pointer;

            }
            .name-artist{
                text-align: center;
                margin-top: 11px;

                p{
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 20px;
                    letter-spacing: -0.3px;
                    color: #B6B6B6;
                    margin: 0;

                    &.nickname{
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 18px;
                        letter-spacing: -0.3px;
                        color: #B6B6B6;
                        margin: 4px 0 0 0 ;

                    }
                }
            }

            .box-input{
                display: flex;
                justify-content: space-between;
                align-items: center;

                .col-info-50{
                    width: calc(50% - 5px) ;
                   
                }
                
            }
            input{
                width: 100%;
                border: none;
                outline: none;
                border-radius: 10px;
                background-color: #464646;
                height: 42px;
                padding: 0 16px;
                color: #fff;
                margin-bottom: 10px;
                :placeholder{

                }
            }
            
        }
        .modal-art-footer {
            height: 78px;
            width: 100%;
            box-shadow: 0px -0.2px 1px #646464, 0px -2px 20px rgba(0, 0, 0, 0.15);
            display: grid;
            place-items: center;
            padding: 0 16px;

            button{
                width: 100%;
                height: 46px;
                font-size: 16px;
            }

            
        }
        .box-footer {
           
            width: 100%;
            padding: 0 16px 16px;

            .btn-logout{
                width: 100%;
                border-radius: 10px;
                background: #464646;
                height: 42px;
                font-weight: 500;
                font-size: 14px;
                line-height: 18px;
                letter-spacing: -0.3px;
                color: #06F1B9;
                display: grid;
                place-items: center;
                cursor: pointer;
            }

            
        }

        

        .btn-model{                
            width: 100px;
            border: none;
            outline: none;
            background: linear-gradient(259.14deg, #06F1B9 1.32%, #008263 100%);
            border-radius: 10px;
            height: 30px;
            font-weight: 600;
            font-size: 12px;
            line-height: 20px;
            letter-spacing: -0.3px;
            color: #FFFFFF;
            display: grid;
            place-items: center;
            margin: 0 auto;
            cursor: pointer;

        }
    }


`
export default ModalUpdateInfo;


// WEBPACK FOOTER //
// ./src/artist-ui/components/ModalUpdateInfo.js